import { Injectable } from "@angular/core";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserVerificationState } from "@models";
import { UserService } from "@main-services/user.service";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";

@Injectable()
export class DepositsBannerFacade {
	constructor(
		private readonly portfolioFacade: PortfolioFacade,
		private readonly userService: UserService
	) {}

	public getDepositsBannerVisibility$(): Observable<boolean> {
		return combineLatest([
			this.portfolioFacade.isZeroBalance$(),
			this.userService.verificationState$.pipe(map((state) => state === UserVerificationState.VERIFIED))
		]).pipe(map((conditions) => conditions.every((condition) => condition)));
	}
}
